module.exports = __webpack_public_path__ + "media/images/teaching-bg6-ca3e047806f9f5f80fb02477408b67b1.jpeg";